import styled, { css } from "styled-components";
import { Checkbox, Select } from "antd";
import ReactInputMask from "react-input-mask";
import designSystemColors from "../../../../styles";

export const ModalFaturaSend = styled.div`
  width: 100%;

  .modal-fatura__loading {
    width: 100%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item-select__options {
    width: 100%;
    display: flex;
  }

  .item-select__user {
    width: 100%;
    &:not(:first-child) {
      margin-top: 1rem;
    }

    p.title {
      font-size: 14px;
      margin-bottom: 8px;
    }
  }
`;

export const Tab = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 16px;
  width: 100%;

  height: 48px;

  p {
    padding: 0;
    margin: 0;
    font-size: 16px;
  }

  ${(props) =>
    props.selected
      ? css`
          background: ${designSystemColors.generalButtons};
          border: 1px solid ${designSystemColors.generalButtons};
          color: ${designSystemColors.background};
          p {
            font-weight: bold;
          }
        `
      : css`
          background: ${designSystemColors.backgroundGray};
          border: 1px solid ${designSystemColors.backgroundGray};
        `}
`;

export const FormWrapper = styled.div`
  margin-top: 16px;
  width: 100%;
  form {
    width: 100%;
    display: flex;
    flex-direction: column;

    .item-submit {
      width: 100%;
      margin-top: 16px;
      border-top: 1px solid #d9d9d9;
      padding-top: 16px;

      display: flex;
      justify-content: flex-end;
      gap: 8px;
    }
  }
`;

export const CustomSelect = styled(Select)`
  &.ant-select-disabled {
    .ant-select-selector {
      background: #ccc !important;
      opacity: 0.4 !important;
    }
  }

  &.error-id:not(.ant-select-disabled) {
    .ant-select-selector {
      border: 1px solid #ff4d4f !important;
    }
  }

  .ant-select-arrow {
    top: 50% !important;
  }
  .ant-select-selector {
    width: 100% !important;
    /* height: 24px; */
    height: 47px !important;
    padding: 8px 12px !important;
    border-radius: 2px !important;
    border: 1px solid var(--neutral-5, #d9d9d9) !important;
    background: var(--neutral-color-gray-1, #fff);

    font-size: 16px;
    outline: 0;
    caret-color: #5188f4;
    color: #434343;

    &.error {
      border-color: #ff4d4f !important;
    }

    &::placeholder {
      color: #bfbfbf !important;
      font-weight: 400 !important;
    }
  }
`;

export const CustomCheckbox = styled(Checkbox)`
  margin: 8px 0;
  width: fit-content;
`;

export const CustomInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border-radius: 2px;
  border: 1px solid var(--neutral-5, #d9d9d9);
  background: var(--neutral-color-gray-1, #fff);

  font-size: 16px;
  outline: 0;
  caret-color: #5188f4;
  color: #434343;

  &:disabled {
    background: #ccc !important;
    opacity: 0.4;
    cursor: no-drop;

    &::placeholder {
      color: #000;
    }
  }

  &.error-id {
    border: 1px solid ${designSystemColors.errorColor};
  }

  &::placeholder {
    color: #bfbfbf;
    font-weight: 400;
  }
`;

export const CustomReactInputMask = styled(ReactInputMask)`
  width: 100%;
  padding: 8px 12px;
  border-radius: 2px;
  border: 1px solid var(--neutral-5, #d9d9d9);
  background: var(--neutral-color-gray-1, #fff);

  font-size: 16px;
  outline: 0;
  caret-color: #5188f4;
  color: #434343;

  &:disabled {
    background: #ccc !important;
    opacity: 0.4;
    cursor: no-drop;

    &::placeholder {
      color: #000;
    }
  }

  &::placeholder {
    color: #bfbfbf;
    font-weight: 400;
  }
`;
